export var EPreferencePersistScope;
(function (EPreferencePersistScope) {
    EPreferencePersistScope[EPreferencePersistScope["InMemory"] = 0] = "InMemory";
    EPreferencePersistScope[EPreferencePersistScope["LocalStorage"] = 1] = "LocalStorage";
    EPreferencePersistScope[EPreferencePersistScope["RemoteUser"] = 2] = "RemoteUser";
    EPreferencePersistScope[EPreferencePersistScope["RemoteBroker"] = 3] = "RemoteBroker";
})(EPreferencePersistScope || (EPreferencePersistScope = {}));
